import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import Button from '../common/Button';

const ContactSection: React.FC = () => {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        backgroundColor: "#FFFFFF",
        py: { xs: 10, md: 12 },
      }}
    >
      <Container maxWidth="xl" sx={{ width: "90%", margin: "0 auto" }}>
        <Box
          sx={{
            display: "flex",
            py: { xs: 10, md: 12 },
            flexDirection: "column",
            alignItems: "center",
            gap: { md: "32px", xs: "24px" },
            borderRadius: "16px",
            backgroundColor: "#5378C3",
            boxShadow: '0px 72px 64px -16px rgba(0, 0, 0, 0.08)',
          }}
        >
      {/* CTA Content */}
      <Box sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { md: "32px", xs: "24px" },
        maxWidth: "756px",
        textAlign: 'center'
      }}>
        <Typography
          variant='h2'
          sx={{
            fontSize: { xs: '38px', md: '48px' },
            fontWeight: 600,
            color: "#FFFFFF",
          }}
        >
          Interested?
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: '16px', md: '18px' },
            color: "#FFFFFF",
            opacity: 0.9,
            lineHeight: 1.6,
          }}
        >
          Contact us, we will present you the software and answer on your questions.
        </Typography>

        <Button href="mailto:official@akrbit.com" variant="cyan">
          official@akrbit.com
        </Button>
      </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ContactSection;
